module.exports = __webpack_public_path__ + "static/media/vacaaguja.f185ccff.jpg";